module.exports = __webpack_public_path__ + "static/ma-5-dfec2961fcca07d7782a2a11396a61a6.png";